declare var jQuery: any;
declare var wp: any;
declare var window: any;
declare var plupload: any;
declare var _: any;
declare var _wpPluploadSettings: any;
declare var frontendUploadLocalize: any;
declare var vmMarketing: any;
import swal from 'sweetalert';
import { Ajax } from './ajax_helper';
import * as CryptoJS from 'crypto-js';
// @ts-ignore
import ImageTools from './ImageTools.js';

// Add function to check if we're on a viwec template page
function isViwecTemplatePage(): boolean {
    return typeof vmMarketing !== 'undefined';
}

// Add function to show alert only if not on viwec template
function showAlert(title: string, message: string, type: string = 'warning') {
    if (!isViwecTemplatePage()) {
        swal(title, message, type);
    }
}

export function string_to_slug(str: any) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaeeeeiiiioooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

jQuery(document).ready(function ($: any) {
    const ajax = new Ajax(frontendUploadLocalize.ajax_url, frontendUploadLocalize.nonce);
    const max_file_size = frontendUploadLocalize.max_upload_file_size_MB; // In MB
    const displayable_images = ['image/gif', 'image/jpeg', 'image/png', 'image/x-icon', 'image/webp']; //based on file_is_displayable_image function in wp-includes/functions.php from WP images.php

    var newWpMedia: any = {};
    var rmlFolderValue = -1;

    var expiredSession = false;

    function hasValidB2UploadUrls(): boolean {
        const details = frontendUploadLocalize?.frontend_upload_details;
        if (!details || typeof details !== 'object' || !Array.isArray(details.upload_urls) || details.upload_urls.length === 0) {
            return false;
        }
        const first = details.upload_urls[0];
        return typeof first?.url === 'string' && first.url.length > 0 && typeof first?.token === 'string';
    }

    function safePluploadStart(up: any): void {
        const url = up?.settings?.url;
        if (typeof url !== 'string' || url.length === 0) {
            console.error('[lms-front-end-upload] Cannot start plupload: upload URL is missing');
            return;
        }
        up.start();
    }

    /**
     * lms_product_upload_file may return success with null attachment_for_js if WP prepare fails.
     */
    function parseLmsProductUploadResponse(resp: any): { id: number; attachment: any } | null {
        if (!resp || !resp.success || !resp.data) {
            return null;
        }
        const js = resp.data.attachment_for_js;
        if (js && js.id) {
            const id = parseInt(String(js.id), 10);
            if (!isNaN(id) && id > 0) {
                return { id, attachment: js };
            }
        }
        const attachmentId = resp.data.attachment_id;
        if (attachmentId) {
            const id = parseInt(String(attachmentId), 10);
            if (!isNaN(id) && id > 0) {
                return { id, attachment: js && typeof js === 'object' ? js : { id } };
            }
        }
        return null;
    }

    function handleLmsProductUploadFailure(up: any, file: any, resp: any): void {
        const message =
            (resp && resp.data && typeof resp.data === 'string' && resp.data) ||
            (resp && resp.data && resp.data.message) ||
            (Array.isArray(resp?.data) && resp.data[0]?.message) ||
            'Could not register the uploaded file in the media library.';
        showAlert('Could not upload file', message);
        try {
            file.status = plupload.FAILED;
            up.trigger('Error', {
                code: 'VM_ATTACHMENT_JS',
                message,
                file,
                response: JSON.stringify(resp || {}),
                status: 500,
                responseHeaders: [],
            });
        } catch (e) {
            // ignore
        }
        safePluploadStart(up);
    }

    /**
     * WP core FileUploaded runs before our B2 → lms_product_upload_file chain and queues a false error.
     * wp.Uploader.errors is a Backbone.Collection (not an array) — must use .where() / .remove().
     */
    function clearUploaderErrorForFile(file: any): void {
        try {
            const Uploader = (window as any).wp?.Uploader;
            if (!Uploader || !Uploader.errors) {
                return;
            }
            const errors = Uploader.errors;

            if (errors && typeof errors.where === 'function' && typeof errors.remove === 'function') {
                let models = errors.where({ file: file });
                if (!models.length && typeof errors.each === 'function') {
                    models = [];
                    errors.each((model: any) => {
                        const entryFile =
                            typeof model.get === 'function' ? model.get('file') : model.file;
                        if (entryFile === file) {
                            models.push(model);
                        }
                    });
                }
                models.forEach((model: any) => errors.remove(model));
            } else if (Array.isArray(errors)) {
                Uploader.errors = errors.filter((entry: any) => entry.file !== file);
            }

            if (Uploader.views?.errors && typeof Uploader.views.errors.render === 'function') {
                Uploader.views.errors.render();
            }

            const isEmpty =
                (typeof errors.isEmpty === 'function' && errors.isEmpty()) ||
                (Array.isArray(Uploader.errors) && Uploader.errors.length === 0);

            const $bar = jQuery('.media-uploader-status .upload-errors');
            if ($bar.length && isEmpty) {
                $bar.hide();
            }
        } catch (_) {
            // silent
        }
    }

    function queueHasUploadingAttachments(queue: any): boolean {
        if (!queue) {
            return false;
        }
        const test = (att: any) => !!(att?.get && att.get('uploading'));
        if (typeof queue.any === 'function') {
            return queue.any(test);
        }
        if (typeof queue.some === 'function') {
            return queue.some(test);
        }
        let found = false;
        if (typeof queue.each === 'function') {
            queue.each((att: any) => {
                if (test(att)) {
                    found = true;
                }
            });
        }
        return found;
    }

    /**
     * Keep the plupload status bar in sync with the file that is actually uploading.
     */
    function syncUploaderProgressForFile(wpUploaderInstance: any, file: any): void {
        if (!file?.attachment || typeof file.attachment.set !== 'function') {
            return;
        }
        const progressKeys = ['loaded', 'size', 'percent'];
        const progress: Record<string, unknown> = { uploading: true };
        progressKeys.forEach((key) => {
            if (file[key] !== undefined) {
                progress[key] = file[key];
            }
        });
        file.attachment.set(progress);
        if (wpUploaderInstance && typeof wpUploaderInstance.progress === 'function') {
            wpUploaderInstance.progress(file.attachment);
        }
        jQuery('.media-uploader-status').show();
    }

    /**
     * Complete upload.php / media grid UI after B2 + lms_product_upload_file succeed.
     */
    function finishWpGridUploadSuccess(
        up: any,
        file: any,
        attachmentForJs: any,
        wpUploaderInstance?: any
    ): void {
        clearUploaderErrorForFile(file);

        const wpMedia = (window as any).wp?.media;
        const Uploader = (window as any).wp?.Uploader;
        file.post_id = attachmentForJs.id;
        file.status = plupload.DONE;
        (file as any)._vmB2UploadComplete = true;

        if (wpMedia?.model?.Attachment) {
            const destroyed =
                !file.attachment ||
                file.attachment.destroyed === true ||
                typeof file.attachment.set !== 'function';
            if (destroyed) {
                file.attachment = wpMedia.model.Attachment.create(
                    Object.assign({ uploading: false }, attachmentForJs)
                );
            } else {
                const model = wpMedia.model.Attachment.create(attachmentForJs);
                const attrs = typeof model.toJSON === 'function' ? model.toJSON() : model.attributes;
                file.attachment.set(attrs);
            }
        }

        if (file.attachment) {
            ['file', 'loaded', 'size', 'percent'].forEach((key) => {
                if (typeof file.attachment.unset === 'function') {
                    file.attachment.unset(key);
                }
            });
            file.attachment.set(Object.assign({}, attachmentForJs, { uploading: false }));

            if (wpMedia?.model?.Attachment?.get && attachmentForJs?.id) {
                wpMedia.model.Attachment.get(attachmentForJs.id, file.attachment);
            }

            if (wpUploaderInstance && typeof wpUploaderInstance.success === 'function') {
                wpUploaderInstance.success(file.attachment);
            }

            if (Uploader?.queue && typeof Uploader.queue.remove === 'function') {
                Uploader.queue.remove(file.attachment);
            }
        }

        const stillUploading =
            queueHasUploadingAttachments(Uploader?.queue) ||
            up.files.some((f: any) => {
                return (
                    f !== file &&
                    f.status !== plupload.DONE &&
                    f.status !== plupload.FAILED &&
                    !(f as any)._vmB2UploadComplete
                );
            });

        if (!stillUploading && Uploader?.queue && typeof Uploader.queue.reset === 'function') {
            Uploader.queue.reset();
            jQuery('.media-uploader-status').hide();
        } else {
            const nextFile = up.files.find((f: any) => {
                return (
                    f !== file &&
                    f.status !== plupload.DONE &&
                    f.status !== plupload.FAILED &&
                    !(f as any)._vmB2UploadComplete
                );
            });
            if (nextFile && wpUploaderInstance) {
                syncUploaderProgressForFile(wpUploaderInstance, nextFile);
            }
        }

        refreshMediaLibraryAfterUpload(attachmentForJs);
        safePluploadStart(up);
    }

    /**
     * Refresh upload.php grid / media modal after B2 manual upload completes.
     */
    function refreshMediaLibraryAfterUpload(attachmentForJs?: any): void {
        if (!attachmentForJs) {
            return;
        }
        try {
            const wpMedia = (window as any).wp?.media;
            if (!wpMedia) {
                return;
            }

            const frame = wpMedia.frame;
            const library = frame?.library;
            if (library?.collection && wpMedia.model?.Attachment) {
                const existing = wpMedia.model.Attachment.get(attachmentForJs.id);
                const model = existing || wpMedia.model.Attachment.create(attachmentForJs);
                if (!existing) {
                    library.collection.add(model);
                } else {
                    existing.set(attachmentForJs);
                }
                if (library.collection.props) {
                    if (typeof library.collection._requery === 'function') {
                        library.collection._requery(true);
                    } else {
                        library.collection.props.set({ ignore: Date.now() });
                    }
                }
            }

            if (frame && typeof frame.content?.get === 'function') {
                const content = frame.content.get();
                if (content?.collection) {
                    if (typeof content.collection._requery === 'function') {
                        content.collection._requery(true);
                    } else {
                        content.collection.props.set({ ignore: Date.now() });
                        content.collection.fetch();
                    }
                }
            }
        } catch (_) {
            // silent
        }
    }

    /**
     * Reposition moxie file-input shims after the upload UI becomes visible.
     * Plupload often initializes while .uploader-inline is hidden (0×0 shim).
     */
    function refreshAllPluploadBrowsers(): void {
        jQuery('.plupload').each(function (_index: number, element: any) {
            const up = element?.uploader;
            if (up && typeof up.refresh === 'function') {
                try {
                    up.refresh();
                } catch (_) {}
            }
        });

        try {
            const frameUp = window.wp?.media?.frame?.uploader?.uploader;
            if (frameUp && typeof frameUp.refresh === 'function') {
                frameUp.refresh();
            }
        } catch (_) {}
    }

    function hookPluploadBrowseRefresh(): void {
        jQuery(document).on('click', '.wrap a.page-title-action', function () {
            window.setTimeout(refreshAllPluploadBrowsers, 0);
        });

        jQuery(document).on('plupload:init', function (_event: any, uploader: any) {
            if (!uploader || typeof uploader.bind !== 'function') {
                return;
            }
            uploader.bind('PostInit', function (up: any) {
                if (typeof up.refresh === 'function') {
                    up.refresh();
                }
            });
        });

        if (typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver(function (mutations) {
                let shouldRefresh = false;
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType !== Node.ELEMENT_NODE) {
                            return;
                        }
                        const el = node as Element;
                        if (
                            (el.classList && el.classList.contains('uploader-inline')) ||
                            (el.querySelector && el.querySelector('.uploader-inline, .plupload, .browser.button-hero'))
                        ) {
                            shouldRefresh = true;
                        }
                    });
                });
                if (shouldRefresh) {
                    window.setTimeout(refreshAllPluploadBrowsers, 0);
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }

    const VALID_DRIVES = ['media_gallery', 'user_files', 'my_files', 'org_drive', 'shared', 'trash'];
    const DRIVES_REQUIRING_FOLDER = ['org_drive', 'user_files', 'my_files'];
    const DRIVE_TO_BUCKET_TYPE: Record<string, string> = {
        media_gallery: 'media-gallery',
        org_drive: 'org-drive',
        user_files: 'user-files',
        my_files: 'user-files',
    };

    function getEffectiveUploadDrive(): string {
        return getCurrentDrive() || 'media_gallery';
    }

    function driveToBucketType(drive: string | null): string {
        if (!drive) {
            return 'media-gallery';
        }
        return DRIVE_TO_BUCKET_TYPE[drive] || 'media-gallery';
    }

    function getCachedUploadDrive(): string | null {
        return frontendUploadLocalize._vmCachedUploadDrive ?? null;
    }

    function setCachedUploadDrive(drive: string): void {
        frontendUploadLocalize._vmCachedUploadDrive = drive;
    }

    function invalidateUploadDetailsIfDriveMismatch(): void {
        const current = getEffectiveUploadDrive();
        if (getCachedUploadDrive() !== current) {
            frontendUploadLocalize.frontend_upload_details = null;
            frontendUploadLocalize._vmCachedUploadDrive = null;
        }
    }

    function uploadDetailsMatchCurrentDrive(): boolean {
        return getCachedUploadDrive() === getEffectiveUploadDrive() && hasValidB2UploadUrls();
    }

    function fetchUploadDetailsForCurrentDrive(up: any, file: any, onReady: () => void): void {
        up.stop();
        ajax.restartData();
        frontendUploadLocalize.frontend_upload_details = null;
        const currentDrive = getCurrentDrive();
        if (currentDrive) {
            ajax.setData('drive_type', currentDrive);
        }
        const rmlFolderForMode = resolveCurrentFolderIdForUpload();
        if (rmlFolderForMode && rmlFolderForMode > 0) {
            ajax.setData('rml_folder', rmlFolderForMode);
        }
        ajax.callWPAjax('check_vmuplink_storage_mode', (resp: any) => {
            if (resp.success && resp.data.mode === 'manual') {
                frontendUploadLocalize.frontend_upload_details = resp.data['frontend_upload_details'] ?? null;
                setCachedUploadDrive(getEffectiveUploadDrive());
                window.lms_bb_token_refresher.init();
                if (!hasValidB2UploadUrls() || typeof window.lms_bb_token_refresher.upload_url !== 'string') {
                    showAlert('Upload not ready', 'Could not get B2 upload URLs. Try reloading the page or try again in a moment.');
                    up.trigger('Error', { code: 'NO_URL', message: 'B2 upload URLs unavailable', file, response: '', status: 0, responseHeaders: [] });
                    return;
                }
                onReady();
            } else {
                showAlert(
                    'Refresh required',
                    'Storage settings changed since last page load. Please reload the page to apply changes.'
                );
                up.trigger('Error', {
                    code: '500',
                    message: '',
                    file,
                    response: resp.data['message'],
                    status: 500,
                    responseHeaders: [],
                });
            }
        }, (err: any) => {
            console.error('check_vmuplink_storage_mode failed', err);
            if (frontendUploadLocalize.frontend_upload_details) {
                try {
                    onReady();
                } catch (e) {
                    console.error(e);
                }
            } else {
                showAlert('Upload init failed', 'Could not get upload URLs. Try reloading and uploading again.');
            }
        });
    }

    function getCurrentDrive(): string | null {
        try {
            const params = new URLSearchParams(window.location.search);
            const d = params.get('drive');
            if (d && VALID_DRIVES.indexOf(d) !== -1) return d;
        } catch (_) {}
        const win = window as any;
        const tabDrive = win.mediaLibraryTabs?.currentDrive;
        if (typeof tabDrive === 'string' && VALID_DRIVES.indexOf(tabDrive) !== -1) return tabDrive;
        if (typeof win.vmCurrentDrive === 'string' && VALID_DRIVES.indexOf(win.vmCurrentDrive) !== -1) return win.vmCurrentDrive;
        return null;
    }

    /**
     * Resolve the currently selected RML folder id.
     * Priority: rml.store.selectedId → getRMLCurrentFolder() → vmCurrentRMLFolder → cookie.
     */
    function resolveCurrentFolderIdForUpload(): number | null {
        // 1. RML store (single source of truth)
        try {
            const rml = (window as any).rml;
            if (rml && rml.store && rml.store.selectedId !== undefined) {
                const storeId = rml.store.selectedId;
                if (storeId === 'all') return -1;
                const n = typeof storeId === 'number' ? storeId : parseInt(String(storeId), 10);
                return (!isNaN(n) && n > 0) ? n : -1;
            }
        } catch (_) {}

        // 2. Tracker API
        if (typeof window.getRMLCurrentFolder === 'function') {
            const rmlFolder = window.getRMLCurrentFolder();
            if (rmlFolder && rmlFolder > 0) return rmlFolder;
        }

        // 3. Global cache
        if ((window as any).vmCurrentRMLFolder && Number((window as any).vmCurrentRMLFolder) > 0) {
            return Number((window as any).vmCurrentRMLFolder);
        }

        // 4. Cookie
        const cookieMatch = document.cookie.match(/rml_folder=([^;]+)/);
        if (cookieMatch) {
            const cookieFolderId = parseInt(cookieMatch[1], 10);
            if (cookieFolderId > 0) return cookieFolderId;
        }

        return null;
    }

    /**
     * Show a WordPress admin notice instead of swal for folder-required errors.
     * Includes explicit dismiss button and appends after the last existing notice.
     */
    function showFolderRequiredNotice(message: string): void {
        try {
            jQuery('.vm-folder-required-notice').remove();
            const escaped = jQuery('<div>').text(message).html();
            const notice = jQuery(
                '<div class="vm-folder-required-notice notice notice-error is-dismissible" style="margin: 1em 0;">' +
                '<p>' + escaped + '</p>' +
                '<button type="button" class="notice-dismiss"><span class="screen-reader-text">Dismiss this notice.</span></button>' +
                '</div>'
            );
            notice.on('click', '.notice-dismiss', function() {
                notice.fadeOut(200, function() { notice.remove(); });
            });
            const wrap = jQuery('#wpbody-content .wrap').first();
            const lastNotice = wrap.find('.notice, .updated, .error').last();
            if (lastNotice.length) {
                lastNotice.after(notice);
            } else if (wrap.length) {
                wrap.prepend(notice);
            } else {
                jQuery('#wpbody-content').prepend(notice);
            }
        } catch (_) {
            // silent
        }
    }

    /**
     * Check if upload should be blocked because no folder is selected on a drive that requires one.
     * Returns true if blocked (caller should abort), false if allowed.
     */
    function checkFolderRequiredAndBlock(up: any): boolean {
        const currentDrive = getCurrentDrive();
        if (!currentDrive || DRIVES_REQUIRING_FOLDER.indexOf(currentDrive) === -1) {
            return false;
        }
        const folderId = resolveCurrentFolderIdForUpload();
        if (folderId && folderId > 0) {
            return false;
        }
        const driveName = currentDrive.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
        showFolderRequiredNotice(`Please select a folder before uploading. Files must be uploaded to a specific folder in ${driveName}.`);
        up.stop();
        return true;
    }

    window.lms_bb_token_refresher = {
        upload_url: undefined as string | undefined,
        auth_token: undefined as string | undefined,
        init() {
            if (!hasValidB2UploadUrls()) {
                return;
            }
            const details = frontendUploadLocalize.frontend_upload_details;
            this.upload_url = details.upload_urls[0].url;
            this.auth_token = details.upload_urls[0].token;

            Object.entries(frontendUploadLocalize.thumb_sizes).map(([key, value], i: any) => {
                const upload_url = details.upload_urls[i + 1];
                if (upload_url?.url && upload_url?.token) {
                    frontendUploadLocalize.thumb_sizes[key].upload_url = upload_url.url;
                    frontendUploadLocalize.thumb_sizes[key].auth_token = upload_url.token;
                }
            });
        },
    }

    function overrideFronEndUpload() {

        if (typeof wp !== 'undefined') {
            if (!wp) {
                return;
            }
        } else {
            return;
        }

        // Hook into wp.media cretion to hijack the uploader


        if (window.wp.original_wp_media) {
            return;
        }
        if (!wp.media) {
            // console.error('wp.media is undefined');
            // setTimeout(() => {
            // overrideFronEndUpload();
            // overrideFrontEndImageEdit();
            // }, 1000);
            return;
        }

        wp.original_wp_media = wp.media;
        const sha1Hashes: any = {};
        wp.media = function (attributes: any) {
            newWpMedia = wp.original_wp_media(attributes);
            if (!attributes.ms_offload) {

                //The set timeout is to make sure the uploader is initialized after the ready event is fired to all the views of the media modal
                setTimeout(() => {
                    if (newWpMedia.uploader) {

                        const wpUploaderInstance = newWpMedia.uploader.uploader;
                        const pluploadInstance = newWpMedia.uploader.uploader.uploader;

                        // Set the max file size
                        pluploadInstance.settings.filters.max_file_size = Math.ceil(max_file_size * 1000000) + "b";

                        pluploadInstance.bind('UploadProgress', function (_up: any, file: any) {
                            syncUploaderProgressForFile(wpUploaderInstance, file);
                        });

                        pluploadInstance.bind('FilesAdded', function (up: any, files: any) {
                            // Block file selection if drive requires a folder and none is selected
                            const currentDrive = getCurrentDrive();
                            if (currentDrive && DRIVES_REQUIRING_FOLDER.indexOf(currentDrive) !== -1) {
                                const folderId = resolveCurrentFolderIdForUpload();
                                if (!folderId || folderId <= 0 || folderId === -1) {
                                    up.stop();

                                    // Defer: WP's FilesAdded handler already rendered the files in the UI.
                                    // We clean up after the event finishes to avoid fighting WP's state.
                                    setTimeout(() => {
                                        // Always remove files[0] — removeFile re-indexes the array.
                                        // Cache length first since it shrinks on each removal.
                                        const count = up.files.length;
                                        for (let i = 0; i < count; i++) {
                                            if (up.files[0]) {
                                                up.removeFile(up.files[0]);
                                            }
                                        }
                                        // Hide the uploader status bar ("N files remaining / 0%")
                                        jQuery('.media-uploader-status').hide();
                                    }, 1);

                                    const driveName = currentDrive.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
                                    showFolderRequiredNotice(`Please select a folder before selecting files. Uploads to ${driveName} require a folder.`);
                                    return;
                                }
                            }
                        });

                        pluploadInstance.bind('BeforeUpload', function (up: any, file: any) {
                            // Block upload if drive requires a folder and none is selected
                            if (checkFolderRequiredAndBlock(up)) {
                                return false;
                            }

                            const HandleBeforeUpload = (up: any, file: any) => {
                                if (!file.new_file_name) {
                                    const randomString = Math.random().toString(36).substring(2, 15);
                                    const fileNameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
                                    const fileExtension = file.name.slice(file.name.lastIndexOf('.'));
                                    file.new_file_name = string_to_slug(fileNameWithoutExtension) + '_' + randomString + fileExtension;
                                }

                                if (!sha1Hashes[file.new_file_name]) {
                                    //Stops queue
                                    up.stop();
                                    file.status = plupload.STOPPED;

                                    const reader: any = new FileReader();
                                    reader.onload = function () {

                                        const hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(reader.result));
                                        sha1Hashes[file.new_file_name] = hash.toString(CryptoJS.enc.Hex);

                                        up.settings.headers = {};

                                    file['X-Bz-File-Name'] = frontendUploadLocalize.backblaze_upload_path + '/' + file.new_file_name;
                                    up.settings.headers = {
                                        ...up.settings.headers,
                                        ...frontendUploadLocalize.base_upload_headers
                                    };
                                    up.settings.headers['X-Bz-File-Name'] = file['X-Bz-File-Name'];
                                    up.settings.headers['Content-Type'] = file.type;
                                    up.settings.headers['Authorization'] = window.lms_bb_token_refresher.auth_token;
                                    up.settings.headers['X-Bz-Content-Sha1'] = hash;
                                    //up.settings.headers['X-Bz-Info-b2-cache-control'] = "public; max-age=31536000";

                                    const uploadUrl = window.lms_bb_token_refresher.upload_url;
                                    if (typeof uploadUrl !== 'string' || uploadUrl.length === 0) {
                                        showAlert("Upload not ready", "B2 upload URL is missing. Try reloading the page or try again in a moment.");
                                        up.trigger('Error', { code: 'NO_URL', message: 'B2 upload URL missing', file, response: '', status: 0, responseHeaders: [] });
                                        return;
                                    }
                                    up.settings.multipart = false;
                                    up.settings.url = uploadUrl;
                                    up.settings.resize.enabled = false;

                                        //clean data unrelated to backblaze
                                        delete up.settings.multipart_params.fl_upload_type;
                                        delete up.settings.multipart_params._wpnonce;
                                        delete up.settings.multipart_params.action;
                                        delete up.settings.multipart_params.name;
                                        delete up.settings.multipart_params.post_id;

                                        //Generate the thumbs in case of images
                                        if (file.type.startsWith('image/') && displayable_images.includes(file.type)) {
                                            const nativeFile = file.getNative();

                                            const getImageDimensions = (nativeFile: File): Promise<{ width: number, height: number }> => {
                                                return new Promise((resolve, reject) => {
                                                    const imgReader = new FileReader();
                                                    imgReader.onload = function (e) {
                                                        const img: any = new Image();
                                                        img.src = e.target.result;
                                                        img.onload = function () {
                                                            const width = img.naturalWidth;   // Get the width
                                                            const height = img.naturalHeight; // Get the height
                                                            resolve({ width, height });
                                                        };
                                                    }
                                                    imgReader.onerror = function (err) {
                                                        reject(err);
                                                    }
                                                    imgReader.readAsDataURL(nativeFile);
                                                });
                                            }

                                            getImageDimensions(nativeFile)
                                                .then((dimensions) => {
                                                    file.lms_dimensions = dimensions;

                                                    setTimeout(() => {
                                                        file.status = plupload.QUEUED;
                                                        safePluploadStart(up);
                                                    }, 10)
                                                });
                                        } else {
                                            //Continue upload queue, starting form this upload
                                            setTimeout(() => {
                                                file.status = plupload.QUEUED;
                                                safePluploadStart(up);
                                            }, 10)
                                        }

                                    };

                                    const source = file.getNative();
                                    reader.readAsBinaryString(source);
                                    return false;
                                }

                                return true;
                            }

                            invalidateUploadDetailsIfDriveMismatch();

                            if (!uploadDetailsMatchCurrentDrive()) {
                                fetchUploadDetailsForCurrentDrive(up, file, () => HandleBeforeUpload(up, file));
                                return false;
                            }

                            if (!hasValidB2UploadUrls() || typeof window.lms_bb_token_refresher.upload_url !== 'string') {
                                showAlert('Upload not ready', 'B2 upload URLs are missing. Try reloading the page.');
                                up.trigger('Error', { code: 'NO_URL', message: 'B2 upload URL missing', file, response: '', status: 0, responseHeaders: [] });
                                return false;
                            }
                            return HandleBeforeUpload(up, file);

                            return false;
                        });

                        pluploadInstance.bind('FileUploaded', function (up: any, file: any, response: any) {
                            if (file.post_id || (file as any)._vmB2UploadComplete) {
                                return true;
                            }

                            (file as any)._vmB2PendingRegistration = true;
                            clearUploaderErrorForFile(file);
                            setTimeout(() => clearUploaderErrorForFile(file), 0);
                            setTimeout(() => clearUploaderErrorForFile(file), 100);

                            const resp: any = JSON.parse(response.response);
                            resp.success = true;
                            resp.post_mime_type = file.type;
                            resp._wp_attached_file = file['X-Bz-File-Name'];
                            if (file.type.startsWith('image/') && displayable_images.includes(file.type)) {
                                resp.width = file.lms_dimensions.width;
                                resp.height = file.lms_dimensions.height;
                            }
                            response.response = JSON.stringify(resp);
                            console.log('response', response)

                            up.stop();

                            ajax.restartData();
                            ajax.setData('backblaze_response', resp);
                            if (file.type.startsWith('image/') && displayable_images.indexOf(file.type) !== -1) {
                                ajax.setData('lms_dimensions', file.lms_dimensions);
                            }
                            ajax.setData('file_size', file.size);
                            ajax.setData('name', file.new_file_name);
                            const currentDrive = getCurrentDrive();
                            if (currentDrive) ajax.setData('drive_type', currentDrive);
                            // Get RML folder from unified resolver
                            const rmlFolderForUpload = resolveCurrentFolderIdForUpload();
                            if (rmlFolderForUpload && rmlFolderForUpload > 0) {
                                ajax.setData('rml_folder', rmlFolderForUpload);
                            }
                            ajax.callWPAjax('lms_product_upload_file',
                                (resp: any) => {
                                    const parsed = parseLmsProductUploadResponse(resp);
                                    if (parsed) {
                                        file.post_id = parsed.id;
                                        const attachmentForJs = parsed.attachment;
                                        // Capture folder used for upload so save-attachment-compat uses it (drive widget doesn't set rmlFolderValue)
                                        const uploadRmlFolder = resolveCurrentFolderIdForUpload();
                                        if (uploadRmlFolder != null && uploadRmlFolder > 0) {
                                            (file as any).upload_rml_folder = uploadRmlFolder;
                                        }

                                        if (file.type.startsWith('image/') && displayable_images.indexOf(file.type) !== -1) {
                                            const nativeFile = file.getNative();
                                            const dimensions = file.lms_dimensions;

                                            // Loop through each size in frontendUploadLocalize.thumb_sizes
                                            const thumbsToUpload: any = [];
                                            const checkAllThumbsAreUploaded = () => {
                                                const activeThumbs = thumbsToUpload.filter((thumb: any) => thumb && typeof thumb === 'object');
                                                const allComplete = activeThumbs.length === 0 || activeThumbs.every((thumb: any) => {
                                                    return thumb.attachment_generated || thumb.error;
                                                });

                                                if (allComplete) {
                                                    finishWpGridUploadSuccess(up, file, attachmentForJs, wpUploaderInstance);
                                                }
                                            }

                                            const thumbsUploads = Object.entries(frontendUploadLocalize.thumb_sizes).map(([sizeKey, size]: any, idx: any) => {
                                                if (!size.height) {
                                                    size.height = size.width;
                                                }

                                                if (size.width > dimensions.width && size.height > dimensions.height) {
                                                    //ignore format bigger than the original image
                                                    return 0;
                                                }

                                                const imageTools: any = new ImageTools();

                                                const randomString = Math.random().toString(36).substring(2, 15);
                                                const fileNameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
                                                const fileExtension = file.name.slice(file.name.lastIndexOf('.'));

                                                thumbsToUpload[idx] = {
                                                    new_file_name: string_to_slug([fileNameWithoutExtension, sizeKey].join('_')) + '_' + randomString + fileExtension,
                                                    nativeFile,
                                                    size,
                                                    idx,
                                                    retriedUpload: 0,
                                                    max_upload_retries: 3,
                                                    max_attachment_creation_retries: 3,
                                                    imageTools,
                                                    error: false,
                                                    resizedFile: false,
                                                    hash: false,
                                                    uploaded: false,
                                                    attachment_generated: false,
                                                    onError: function (err: any) {
                                                        this.error = true;
                                                        console.error(err);
                                                        checkAllThumbsAreUploaded();
                                                    },
                                                    onResize: function (resizedFile: any) {
                                                        this.resizedFile = new File([resizedFile], this.new_file_name);

                                                        const thumbReader: any = new FileReader();
                                                        thumbReader.onload = () => {
                                                            this.onHash(CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(thumbReader.result)));
                                                        }
                                                        thumbReader.onerror = (err: any) => {
                                                            this.onError(err);
                                                        }
                                                        thumbReader.readAsBinaryString(this.resizedFile);
                                                    },
                                                    requestNewUploadUrl: function (hash:any, reference:any) {
                                                        // Make request and override this.size.auth_token and this.size.upload_url

                                                        //ajax action request_fresh_offload_point
                                                        ajax.restartData();
                                                        ajax.setData('backblaze_response', resp);
                                                        if (file.type.startsWith('image/') && displayable_images.indexOf(file.type) !== -1) {
                                                            ajax.setData('lms_dimensions', file.lms_dimensions);
                                                        }
                                                        ajax.setData('size', this.size);
                                                        const currentDrive = getCurrentDrive();
                                                        if (currentDrive) {
                                                            ajax.setData('drive_type', currentDrive);
                                                            ajax.setData('type', driveToBucketType(currentDrive));
                                                        }
                                                        ajax.callWPAjax('request_fresh_offload_point', (resp: any) => {
                                                            if (resp.success) {
                                                                const first_url = resp.data['upload_urls'][0];
                                                                reference.size.upload_url = first_url['url'];
                                                                reference.size.auth_token = first_url['token'];
                                                                reference.onHash(hash);
                                                            } else {
                                                                reference.onError(resp.data);
                                                            }
                                                        });
                                                    },
                                                    onHash: function (hash: any) {
                                                        this.hash = hash;
                                                        this['X-Bz-File-Name'] = frontendUploadLocalize.backblaze_upload_path + '/' + this.new_file_name;
                                                        this.private_filename = this.new_file_name

                                                        jQuery.ajax({
                                                            url: this.size.upload_url,
                                                            type: 'POST',
                                                            headers: {
                                                                'Authorization': this.size.auth_token,
                                                                'Content-Type': file.type,
                                                                'X-Bz-File-Name': this['X-Bz-File-Name'],
                                                                'X-Bz-Content-Sha1': this.hash,
                                                                "X-Bz-Info-b2-cache-control": encodeURIComponent("public; max-age=31536000")
                                                            },
                                                            data: this.resizedFile,
                                                            processData: false,
                                                            success: (backblaze_upload_response: any) => {
                                                                backblaze_upload_response.post_mime_type = file.type;
                                                                backblaze_upload_response.private_filename = this.private_filename;
                                                                backblaze_upload_response._wp_attached_file = this['X-Bz-File-Name'];
                                                                this.onUploaded(backblaze_upload_response);
                                                                // Handle the success response here
                                                                console.log('Success:', backblaze_upload_response);
                                                            },
                                                            error: (xhr: any, status: any, error: any) => {
                                                                console.error('Error:', status, error, this);
                                                                if ([500, 503].indexOf(xhr.status) !== -1) {
                                                                    setTimeout(() => {
                                                                        this.requestNewUploadUrl(hash, this);
                                                                    }, 10);
                                                                } else if (this.retriedUpload < this.max_upload_retries) {
                                                                    this.retriedUpload++;
                                                                    setTimeout(() => {
                                                                        this.onHash(hash);
                                                                    }, 10); //wait 10ms and try again in case of uploa failure
                                                                } else {
                                                                    // Handle errors here (B2 may return empty/non-JSON body)
                                                                    showAlert(
                                                                        "Could not upload file",
                                                                        xhr.responseJSON ? xhr.responseJSON.message : "Unknown error"
                                                                    );
                                                                    if (!error) {
                                                                        const raw = xhr.responseText;
                                                                        if (typeof raw === 'string' && raw.trim().length > 0) {
                                                                            try {
                                                                                error = JSON.parse(raw);
                                                                            } catch (_e) {
                                                                                error = { message: raw || 'Upload failed' };
                                                                            }
                                                                        } else {
                                                                            error = { message: 'Upload failed' };
                                                                        }
                                                                    }
                                                                    console.log('Error:', status, error, this);
                                                                    this.onError(error);
                                                                }
                                                            }
                                                        });

                                                        //Ajax request to backblaze uploading the thumb
                                                    },
                                                    onUploaded: function (backblaze_upload_response: any) {
                                                        const addThumbToAttachmentAjax = new Ajax(frontendUploadLocalize.ajax_url, frontendUploadLocalize.nonce);
                                                        addThumbToAttachmentAjax.setData('backblaze_upload_response', backblaze_upload_response);
                                                        addThumbToAttachmentAjax.setData('sizeKey', sizeKey);
                                                        addThumbToAttachmentAjax.setData('attachment_post_id', file.post_id);
                                                        addThumbToAttachmentAjax.setData('lms_dimensions', size);
                                                        addThumbToAttachmentAjax.setData('file_size', this.resizedFile.size);
                                                        addThumbToAttachmentAjax.callWPAjax('lms_add_offloaded_thumb_to_attachment',
                                                            (resp: any) => {
                                                                if (resp.success) {
                                                                    // this.onAttachmentCreated(resp);
                                                                    const dynamicNonce = resp.data.nonce;
                                                                    const attachmentId = resp.data.attachment_id;
                                                                    const saveCompatAjax = new Ajax(frontendUploadLocalize.ajax_url, dynamicNonce);
                                                                    saveCompatAjax.setData('action', 'save-attachment-compat');
                                                                    saveCompatAjax.setData('id', file.post_id);
                                                                    saveCompatAjax.setData('_wpnonce', dynamicNonce);
                                                                    const folderForCompat = ((file as any).upload_rml_folder != null && (file as any).upload_rml_folder > 0)
                                                                        ? (file as any).upload_rml_folder
                                                                        : rmlFolderValue;
                                                                    saveCompatAjax.setData(`attachments[${file.post_id}][rml_folder]`, folderForCompat);

                                                                    saveCompatAjax.callWPAjax(
                                                                        'save-attachment-compat',
                                                                        (saveResp: any) => {
                                                                            console.log('Attachment saved successfully', saveResp);
                                                                            try {
                                                                                if (typeof wp !== 'undefined' && wp.media && wp.media.frame && wp.media.frame.content) {
                                                                                    const content = wp.media.frame.content.get();
                                                                                    if (content && content.collection) {
                                                                                    // Reload the list/grid of attachments
                                                                                    content.collection.props.set({ ignore: (+ new Date()) });
                                                                                    content.collection.fetch();
                                                                                    console.log('Media Library refreshed');
                                                                                    }
                                                                            }
                                                                            } catch (err) {
                                                                                console.warn('Could not refresh media library:', err);
                                                                            }
                                                                            this.onAttachmentCreated(resp);
                                                                        },
                                                                        (error: any) => {
                                                                            showAlert(
                                                                            "Could not save attachment",
                                                                            "Something went wrong while saving attachment metadata."
                                                                            );
                                                                            console.log('Save error', error);
                                                                            this.onError(error);
                                                                        }
                                                                    );
                                                                }
                                                            },
                                                            (error: any) => {
                                                                if (!this.retriedAttachmentCreation) {
                                                                    this.retriedAttachmentCreation = 0;
                                                                }

                                                                if (this.retriedAttachmentCreation < this.max_attachment_creation_retries) {
                                                                    this.retriedAttachmentCreation++;
                                                                    setTimeout(() => {
                                                                        this.onUploaded(backblaze_upload_response);
                                                                    }, 10); //wait 10ms and try again in case of uploa failure
                                                                } else {
                                                                    showAlert(
                                                                        "Could not create thumb",
                                                                        "Could not create attachment for thumb on VMuplink for " + sizeKey + " size"
                                                                    );
                                                                    console.log('Error:', error);
                                                                    this.onError(error);
                                                                }
                                                            }
                                                        );

                                                    },
                                                    onAttachmentCreated: function (resp: any) {
                                                        this.attachment_generated = true;
                                                        checkAllThumbsAreUploaded();
                                                    }
                                                };

                                                imageTools.resize(nativeFile, {
                                                    width: size.width,
                                                    height: size.height,
                                                }).then((resizedFile: any) => {
                                                    thumbsToUpload[idx].onResize(resizedFile);
                                                }).catch((err: any) => {
                                                    thumbsToUpload[idx].onError(err);
                                                });

                                                return 1;
                                            });

                                            //When
                                            if (thumbsToUpload.filter((thumb: any) => thumb !== 0).length === 0) {
                                                checkAllThumbsAreUploaded();
                                            }
                                        } else { //Process if no thumb is needed
                                            finishWpGridUploadSuccess(up, file, attachmentForJs, wpUploaderInstance);
                                        }
                                    } else {
                                        handleLmsProductUploadFailure(up, file, resp);
                                    }
                                },
                                (error: any) => {
                                    showAlert(
                                        "Could not upload file",
                                        "Something went wrong!"
                                    );
                                    try {
                                        file.status = plupload.FAILED;
                                    } catch (_) {
                                        // ignore
                                    }
                                    safePluploadStart(up);
                                }
                            );

                            return false;
                        });

                        //Refreshes the media modal to make sure the uploaded file is displayed
                        pluploadInstance.bind('UploadComplete', function (up: any, files: any) {

                            frontendUploadLocalize.frontend_upload_details = null;
                            if (files.length > 0) {
                                const lastFile = files[files.length - 1];
                                const attachmentForJs = lastFile?.attachment?.toJSON?.() || null;
                                refreshMediaLibraryAfterUpload(attachmentForJs);
                            }
                        });

                        pluploadInstance.bind('Error', function (up: any, err: any, other: any) {
                            console.log('Error', err, up);
                            showAlert(
                                "Could not upload file",
                                err.message ? err.message : "Something went wrong!"
                            );
                        });
                    }
                }, 150);
            }

            //Copy all properties from old wp.media to the new wp.media
            for (const prop in wp.original_wp_media) {

                if (wp.original_wp_media.hasOwnProperty(prop)) {
                    wp.media[prop] = wp.original_wp_media[prop];
                }
            }

            // console.log('newWpMedia', newWpMedia);
            return newWpMedia;
        }

        //Copy all properties from old wp.media to the new wp.media        
        for (const prop in wp.original_wp_media) {

            if (wp.original_wp_media.hasOwnProperty(prop)) {
                wp.media[prop] = wp.original_wp_media[prop];
            }
        }

        Object.assign(wp.media, wp.original_wp_media);
    }

    if (frontendUploadLocalize.backblaze_offload) {
        invalidateUploadDetailsIfDriveMismatch();
        if (!hasValidB2UploadUrls()) {
            frontendUploadLocalize.frontend_upload_details = null;
        } else if (!getCachedUploadDrive()) {
            setCachedUploadDrive(getEffectiveUploadDrive());
        }
        window.lms_bb_token_refresher.init();
        hookPluploadBrowseRefresh();
        
        if (frontendUploadLocalize.is_beaver_builder) {
            setTimeout(() => {
                overrideFronEndUpload();
            }, 500);
        } else {
            overrideFronEndUpload();
        }
    }

    jQuery(document).on('click', '.media-modal .browser.button-hero', function (e) {
        rmlFolderValue = jQuery('input[name="rmlFolder"]').last().val(); 
    });

});
